export default "__VITE_ASSET__9b816ba3__"